import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1280px;
	margin: 0 auto;

	padding: 50px 20px;
	color: ${CSSVars.black};

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h2 {
		text-align: center;
		margin: 0 auto;
		font-size: ${CSSVars.fontSize2XL};

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize3XL};
		}
	}

	.steps {
		display: flex;
		flex-wrap: wrap;
		gap: 50px;
		margin-top: 80px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			gap: 50px;
		}

		.step {
			flex: 300px;
			border: 1px solid ${CSSVars.gray50};
			padding: 50px 20px 20px;
			border-radius: 8px;
			position: relative;

			svg {
				top: -32px;
				position: absolute;
			}

			h4 {
				font-size: ${CSSVars.fontSizeLG};
				font-weight: 500;
				margin-bottom: 10px;
			}

			p {
				font-weight: 300;
				font-size: ${CSSVars.fontSizeMD};
				opacity: 0.8;
			}
		}
	}
`;
